<template>
  <div class="voucher-item inner-wrap">
    <div class="label-area">
      <h3>
        <span>{{ voucherTitle }}</span>
        <span v-if="isInUse" class="icon">이용중</span>
        <span v-if="isUpcoming" class="icon">결제 예약</span>
        <span v-if="isRecommendation" class="icon icon-supplant">추천</span>
      </h3>
    </div>
    <VoucherButtonShort
      v-if="isVoucherTypePartner"
      :key="`button__${voucherType}_${quality}`"
      :voucher="voucher"
      :voucher-item="voucherItem"
      @on-click-purchase="$emit('on-click-purchase-partner', $event)"
    />

    <VoucherTableList
      :key="`table__${voucherType}_${quality}`"
      :support-device="supportDevice"
      :quality="quality"
      :concurrency="concurrency"
    />

    <VoucherButtonStandard
      v-if="isVoucherTypeWavve"
      :key="`button__${voucherType}_${quality}`"
      :voucher="voucher"
      :voucher-item="voucherItem"
      :selected-product-id="selectedProductId"
      @on-click-purchase="$emit('on-click-purchase-wavve', $event)"
    />
  </div>
</template>
<script setup>
  import { ref, computed, defineProps, defineEmits } from 'vue'
  import VoucherButtonShort from '@/components/lnb/voucher/ui/VoucherButtonShort.vue'
  import VoucherButtonStandard from '@/components/lnb/voucher/ui/VoucherButtonStandard.vue'
  import VoucherTableList from '@/components/lnb/voucher/VoucherTableList.vue'

  const props = defineProps({
    voucher: {
      type: Object,
      default: () => {},
      required: true,
    },
    voucherType: {
      type: String,
      default: '',
    },
    selectedProductId: {
      type: String,
      default: '',
    },
  })

  defineEmits(['on-click-purchase-wavve', 'on-click-purchase-partner'])

  const voucherItem = ref({})

  const isVoucherTypeWavve = computed(() => props.voucherType === 'wavve')
  const isVoucherTypePartner = computed(() => props.voucherType === 'partner')
  const isUpcoming = computed(() => voucherItem.value.is_upcoming ?? false)
  const isInUse = computed(() => voucherItem.value.in_use ?? false)
  const isRecommendation = computed(
    () => voucherItem.value.recommendation ?? false,
  )

  const concurrency = computed(() => voucherItem.value.concurrency ?? '')
  const voucherTitle = computed(() => voucherItem.value.product_name ?? '')
  const quality = computed(() => voucherItem.value.quality ?? '')
  const supportDevice = computed(
    () => voucherItem.value.mobile_support_device ?? '',
  )

  const init = () => {
    const [_concurrency] = props.voucher?.concurrency ?? {}
    voucherItem.value = _concurrency
  }

  init()
</script>
